export const CLICK_ACTION_SOURCE = 'Click'; // Action source for when user clicks on suggestion
export const LARGE_SUGGESTION_HEIGHT = 52;
export const NONBREAKING_SPACE_CHAR = String.fromCharCode(160);
export const SMALL_SUGGESTION_HEIGHT = 38;
export const SPACE_REGEX = /\s/g;
export const SUGGESTIONS_CALLOUT_ID = 'searchSuggestionsCallout';
export const SUGGESTION_ID_PREFIX = 'searchSuggestion-';
